import React, { useState, useEffect } from 'react';
import { Plus, Trash2 } from 'lucide-react';
import { createHostelNotice, getHostelNotices, deleteHostelNotice, getHostels } from '../../../services/hostelService';
import toast from 'react-hot-toast';

const HostelNotices = ({ coachingId }) => {
  const [notices, setNotices] = useState([]);
  const [hostels, setHostels] = useState([]);
  const [loading, setLoading] = useState(true);
  const [showForm, setShowForm] = useState(false);
  const [form, setForm] = useState({ title: '', description: '', targetType: 'all', targetHostelId: '' });

  useEffect(() => { loadNotices(); loadHostels(); }, [coachingId]);

  const loadNotices = async () => {
    setLoading(true);
    const data = await getHostelNotices(coachingId);
    setNotices(data);
    setLoading(false);
  };

  const loadHostels = async () => {
    const data = await getHostels(coachingId);
    setHostels(data);
  };

  const handleCreate = async (e) => {
    e.preventDefault();
    if (!form.title.trim()) return toast.error('Title required');
    await createHostelNotice(coachingId, form);
    toast.success('Notice published');
    setShowForm(false);
    setForm({ title: '', description: '', targetType: 'all', targetHostelId: '' });
    loadNotices();
  };

  const handleDelete = async (id) => {
    if (!window.confirm('Delete this notice?')) return;
    await deleteHostelNotice(id);
    toast.success('Deleted');
    loadNotices();
  };

  if (loading) return <div className="flex justify-center py-12"><div className="animate-spin rounded-full h-8 w-8 border-b-2 border-blue-600"></div></div>;

  return (
    <div className="space-y-6">
      <div className="flex items-center justify-between">
        <h2 className="text-lg font-semibold text-gray-800 dark:text-white">Hostel Notices</h2>
        <button onClick={() => setShowForm(true)} className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg text-sm font-medium hover:bg-blue-700">
          <Plus size={16} /> New Notice
        </button>
      </div>

      {showForm && (
        <form onSubmit={handleCreate} className="bg-white dark:bg-gray-800 border rounded-xl p-4 space-y-3">
          <input value={form.title} onChange={e => setForm({...form, title: e.target.value})} placeholder="Notice Title *" className="w-full border rounded-lg px-3 py-2 text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
          <textarea value={form.description} onChange={e => setForm({...form, description: e.target.value})} placeholder="Description" rows={3} className="w-full border rounded-lg px-3 py-2 text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white" />
          <div className="grid grid-cols-1 md:grid-cols-2 gap-3">
            <select value={form.targetType} onChange={e => setForm({...form, targetType: e.target.value})} className="border rounded-lg px-3 py-2 text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white">
              <option value="all">All Hostel Students</option>
              <option value="hostel">Specific Hostel</option>
            </select>
            {form.targetType === 'hostel' && (
              <select value={form.targetHostelId} onChange={e => setForm({...form, targetHostelId: e.target.value})} className="border rounded-lg px-3 py-2 text-sm dark:bg-gray-700 dark:border-gray-600 dark:text-white">
                <option value="">Select Hostel</option>
                {hostels.map(h => <option key={h.id} value={h.id}>{h.name}</option>)}
              </select>
            )}
          </div>
          <div className="flex gap-2">
            <button type="submit" className="px-4 py-2 bg-blue-600 text-white rounded-lg text-sm">Publish</button>
            <button type="button" onClick={() => setShowForm(false)} className="px-4 py-2 border rounded-lg text-sm">Cancel</button>
          </div>
        </form>
      )}

      <div className="space-y-3">
        {notices.map(n => (
          <div key={n.id} className="bg-white dark:bg-gray-800 border rounded-xl p-4 flex items-start justify-between">
            <div>
              <h3 className="font-semibold text-gray-800 dark:text-white">{n.title}</h3>
              {n.description && <p className="text-sm text-gray-500 mt-1">{n.description}</p>}
              <p className="text-xs text-gray-400 mt-2">Target: {n.targetType === 'all' ? 'All Students' : 'Specific Hostel'}</p>
            </div>
            <button onClick={() => handleDelete(n.id)} className="text-red-400 hover:text-red-600 p-1"><Trash2 size={16} /></button>
          </div>
        ))}
        {notices.length === 0 && <p className="text-gray-400 text-sm text-center py-8">No notices published yet.</p>}
      </div>
    </div>
  );
};

export default HostelNotices;
